
import { defineComponent, computed } from 'vue';
import { IParametroItem } from '@/models/Entidades/MeuSistema/Parametros/IParametro';

export default defineComponent({
  name: 'SelecionarValorCampoParametro',
  components: {
  },
  props: {
    valores: {
      type: Object as () => IParametroItem[],
      required: true,
    },
    valor: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:valor', 'change'],
  setup(props, { emit }) {
    const computedValor = computed({
      get: () => props.valor,
      set: (valor: string) => {
        emit('update:valor', valor);
      },
    });

    function change() {
      emit('change', props.valor);
    }

    return {
      props,
      computedValor,
      change,
    };
  },
});
